import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import gql from 'graphql-tag'

const DOC = gql`
  mutation UpdateClusterFunctionalUsage(
    $tenantId: ID!
    $zoneId: ID!
    $appId: ID!
    $scenarioId: ID!
    $clusterId: ID!
    $functionalizations: [SpaceFunctionalizationInput!]
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        app(id: $appId) {
          scenario(id: $scenarioId) {
            extra {
              space {
                updateClusterFunctionalUsage(
                  clusterId: $clusterId
                  functionalizations: $functionalizations
                ) {
                  functionId
                  percent
                }
              }
            }
          }
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.default(
  graphql.transformers.OUT.select<
    graphql.schema.UpdateClusterFunctionalUsageMutation,
    ents.extra.space.Functionalization[] | undefined,
    'tenant'
  >(
    'tenant',
    graphql.transformers.OUT.select(
      'zone',
      graphql.transformers.OUT.select(
        'app',
        graphql.transformers.OUT.select(
          'scenario',
          graphql.transformers.OUT.select(
            'extra',
            graphql.transformers.OUT.select(
              'space',
              graphql.transformers.OUT.select(
                'updateClusterFunctionalUsage',
                graphql.transformers.OUT.list(
                  graphql.transformers.OUT.object({
                    functionId: graphql.transformers.OUT.validate(
                      transformers.PASS_THROUGH,
                      ents.extra.space.Function.Id.isId,
                    ),
                    percent: transformers.PASS_THROUGH,
                  }),
                  { onNullish: 'remove' },
                ),
              ),
            ),
          ),
        ),
      ),
    ),
  ),
  [],
)

export const executor = graphql.createExecutor<
  graphql.schema.UpdateClusterFunctionalUsageMutation,
  ents.extra.space.Functionalization[],
  graphql.schema.UpdateClusterFunctionalUsageMutationVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
